/// <amd-module name="Pipeline/Analytics/PipelineStepsDurationCard/Types" />
import { IStageMetrics } from "Pipeline/Analytics/Common/Types";

export interface IStepDurationData {
    stepName: string;
    stepDuration: number;
}

export interface IPipelineStepDurationTrend {
    date: string;
    stepsDurationData: { [stage: string]: IStepDurationData[] };
}

export interface IStageStepsDurationData {
    stepDurationData: { [stage: string]: { stepsData: IStepDurationData[]; totalStageStepDuration: number } };
    stages?: IStageMetrics[];
}
